import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Menu, LogOut, User, ChevronDown, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import NotificationBell from '@/components/NotificationBell';

const roleLabels = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  manager: 'Manager',
  trader: 'Trader',
  investor: 'Investor',
  office_staff: 'Office Staff',
  receptionist: 'Receptionist',
};

export default function Header({ onToggleSidebar }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header data-testid="header" className="sticky top-0 z-30 h-14 bg-white/80 backdrop-blur-xl border-b border-brand-border/60 flex items-center justify-between px-4 sm:px-6">
      <div className="flex items-center gap-3">
        <button onClick={onToggleSidebar} className="lg:hidden p-1.5 rounded-lg text-brand-text-secondary hover:text-brand-text-primary hover:bg-brand-surface-hover transition-colors" data-testid="menu-toggle-btn">
          <Menu size={20} />
        </button>
        <span className="font-heading text-base font-semibold text-brand-text-primary lg:hidden">Quantora</span>
      </div>
      <div className="flex items-center gap-2">
        <NotificationBell />
        <div className="w-px h-6 bg-brand-border/60 mx-1 hidden sm:block" />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="flex items-center gap-2 h-auto py-1 px-2 hover:bg-brand-surface-hover rounded-lg" data-testid="user-menu-btn">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-primary to-brand-accent flex items-center justify-center text-white text-xs font-bold">
                {user?.name?.charAt(0)?.toUpperCase() || 'U'}
              </div>
              <div className="hidden sm:block text-left">
                <div className="text-xs font-semibold text-brand-text-primary leading-tight">{user?.name}</div>
                <div className="text-[10px] text-brand-text-secondary">{roleLabels[user?.role] || user?.role}</div>
              </div>
              <ChevronDown size={12} className="text-brand-text-secondary hidden sm:block" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuItem onClick={() => navigate('/settings')} className="text-sm">
              <Settings size={14} className="mr-2" />
              Settings
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout} className="text-brand-error text-sm" data-testid="logout-btn">
              <LogOut size={14} className="mr-2" />
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
